import { createContext, useContext } from 'react'

/** Position-based slide number, so labels stay correct when slides are hidden. */
export const SlideNumberContext = createContext<string>('')

export function useSlideNumber() {
  return useContext(SlideNumberContext)
}
